import { cloneDeep } from 'lodash-es';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import trI18n from '@/common/utils/trI18n';


export const validateErrorTicket = (argsCommon, itemField) => {
    if (Utils.isEmptyArray(argsCommon.fieldListData)) {
        return true;
    }

    let itemFieldObj;
    try {
        itemFieldObj = JSON.parse(itemField);
    } catch (err) {
        console.log('validateErrorTicket error ', err);
        return true;
    }

    let fieldList = cloneDeep(argsCommon.fieldListData);

    let isValidateError = false;
    // validate
    fieldList.forEach(field => {
        let isCheck = field.definition !== 'SYSTEM' && field.type === Constant.FORM_TYPE.FIELD_TAG
            && (!Utils.isEmpty(field.structure.required) && field.structure.required);
        if (isCheck) {
            isValidateError = Utils.isEmptyObject(itemFieldObj)
                || Utils.isEmptyArray(itemFieldObj.tagField[`${field.id}`]);
            field.error = {
                isError: isValidateError,
                message: isValidateError ? trI18n('COMM01MSG11') : ''
            }
        }
    });

    if (isValidateError) {
        argsCommon.setFiledListData(fieldList);
    }
    return isValidateError;
};

//validate max size kbs;
export const validateExceedSizeOfFieldTicket = (
    fieldListData,
    setFiledListData,
    listFields,
    setErrorMessageHeader
) => {
    if (Utils.isEmptyObject(listFields)) return;

    let itemFieldObj = Utils.convertJSONDataToObject(listFields);
    let fieldList = cloneDeep(fieldListData);

    const checkTotalRichtextSize = validateTotalRichtextSize(fieldList, itemFieldObj, setErrorMessageHeader);
    if (checkTotalRichtextSize) return true;


    let isValidateError = false;
    for (let field of fieldList) {
        if (field.type === Constant.FORM_TYPE.HTML) continue;

        let fieldValue = itemFieldObj[field.id];
        if (field.type === Constant.FORM_TYPE.FIELD_RICHTEXT) {
            fieldValue = JSON.stringify(fieldValue)
        }

        let errorMessage = [Constant.FORM_TYPE.MARKDOWN, Constant.FORM_TYPE.JSON].includes(field.type)
            ? Utils.validateSizeOfS3TextField(fieldValue)
            : Utils.validateSizeOfFieldTicket(fieldValue);
        if (errorMessage) {
            isValidateError = true;
            field.error = {
                isError: isValidateError,
                message: errorMessage
            };
        }
    }

    if (isValidateError) {
        setFiledListData(fieldList);
    }

    return isValidateError;
};

// Constants for field size validation
// const MAX_TOTAL_RICHTEXT_SIZE_MB = 1;
const MAX_TOTAL_RICHTEXT_SIZE_BYTES = 1024 * 1024; // 1MB

// Calculate total size of all fields in bytes
const calculateTotalTextSize = (fieldList, itemFieldObj) => {
    let totalSizeInBytes = 0;
    const encoder = new TextEncoder();
    
    for (let field of fieldList) {
        let fieldValue = itemFieldObj[field.id];
        if ([Constant.FORM_TYPE.HTML, Constant.FORM_TYPE.MARKDOWN, Constant.FORM_TYPE.JSON].includes(field.type)) continue;
        if (field.type === Constant.FORM_TYPE.FIELD_TAG && itemFieldObj?.tagField) {
            let tagArray = itemFieldObj?.tagField[`${field.id}`] || [];
            if (tagArray.length > 0) {
                fieldValue = tagArray.map(tag => tag.value).join(', ');
            }
        }
       
        // Skip null, undefined, or empty values
        if (fieldValue === null || fieldValue === undefined) continue;
        
        // Convert field value to string based on data type
        let fieldValueStr = '';
        if (typeof fieldValue === 'string') {
            // String: use as is
            if (fieldValue.trim() === '') continue;
            fieldValueStr = fieldValue;
        } else if (typeof fieldValue === 'number') {
            // Number: convert to string
            fieldValueStr = String(fieldValue);
        } else if (typeof fieldValue === 'boolean') {
            // Boolean: convert to string
            fieldValueStr = String(fieldValue);
        } else if (Array.isArray(fieldValue)) {
            // Array (TAG field): stringify
            if (fieldValue.length === 0) continue;
            fieldValueStr = JSON.stringify(fieldValue);
        } else if (typeof fieldValue === 'object') {
            // Object (RICHTEXT field, etc.): stringify
            fieldValueStr = JSON.stringify(fieldValue);
        } else {
            // Other types: stringify
            fieldValueStr = JSON.stringify(fieldValue);
        }
        
        // Calculate byte size using UTF-8 encoding
        const utf8Bytes = encoder.encode(fieldValueStr);
        totalSizeInBytes += utf8Bytes.length;
    }
    
    return totalSizeInBytes;
};


// Validate total size of all fields (max 1MB)
export const validateTotalRichtextSize = (
    fieldList,
    itemFieldObj,
    setErrorMessageHeader
) => {

    let totalSizeInBytes = calculateTotalTextSize(fieldList, itemFieldObj);
    if (totalSizeInBytes > MAX_TOTAL_RICHTEXT_SIZE_BYTES) {
        if (setErrorMessageHeader) {
            setErrorMessageHeader(trI18n('MSG-CM-EXCEED-MAX-TEXT-SIZE'));
        }
        return true;
    }
    if (setErrorMessageHeader) {
        setErrorMessageHeader('');
    }
    return false;
};